import { render } from "./CatDimensionView.vue?vue&type=template&id=7e7d00d3&scoped=true"
import script from "./CatDimensionView.vue?vue&type=script&lang=js"
export * from "./CatDimensionView.vue?vue&type=script&lang=js"

import "./CatDimensionView.vue?vue&type=style&index=0&id=7e7d00d3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7d00d3"]])

export default __exports__